import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import { $kazakhstanPolygon } from '../../../models/investProModel/index.js';

function KazakhstanLayer() {
  const mapLoaded = useUnit($mapLoaded);
  const kazakhstanPolygon = useUnit($kazakhstanPolygon);

  const createLayer = (update) => {
    const kazakhstanData = {
      type: 'FeatureCollection',
      features: kazakhstanPolygon,
    };

    if (update) {
      window.map
        .getSource('invest_pro_kazakhstan_source')
        .setData(kazakhstanData);
    } else {
      if (!window.map.getSource('invest_pro_kazakhstan_source')) {
        window.map.addSource('invest_pro_kazakhstan_source', {
          type: 'geojson',
          data: kazakhstanData,
        });
      }

      if (!window.map.getLayer('invest_pro_kazakhstan_layer')) {
        window.map.addLayer({
          id: 'invest_pro_kazakhstan_layer',
          type: 'line',
          source: 'invest_pro_kazakhstan_source',
          paint: {
            'line-color': 'white',
            'line-width': 5,
          },
        });

        window.map.moveLayer(
          'invest_pro_kazakhstan_layer',
          'invest_pro_regions_layer'
        );
      }
    }
  };

  useEffect(() => {
    if (mapLoaded && kazakhstanPolygon) {
      if (window.map.getLayer('invest_pro_kazakhstan_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, kazakhstanPolygon]);

  return null;
}

export default KazakhstanLayer;
